import { IOrderResponse, OrderStatusType } from "@/shared/types"

export const REPROCESS_ELIGIBLE_STATUSES: OrderStatusType[] = [
  OrderStatusType.Completed,
  OrderStatusType.NotCovered,
  OrderStatusType.CompletedWithNoReason,
  OrderStatusType.TenderingFinished,
]

export const isLatestConnectedOrder = (connectedOrders: IOrderResponse[], currentOrderId: string) => {
  if (connectedOrders.length === 0) {
    return true
  }

  return connectedOrders[connectedOrders.length - 1].orderId === currentOrderId
}

export const canReprocessOrder = ({
  orderStatus,
  isLatestVersion,
  isSysAdmin,
  isCustomerAdmin,
  isOwnOrganization,
  isReprocessEnabled,
}: {
  orderStatus?: string
  isLatestVersion: boolean
  isSysAdmin: boolean
  isCustomerAdmin: boolean
  isOwnOrganization: boolean
  isReprocessEnabled: boolean
}) => {
  const hasPermission = isSysAdmin || (isCustomerAdmin && isOwnOrganization)

  if (!hasPermission || !isLatestVersion || !orderStatus || !isReprocessEnabled) {
    return false
  }

  return REPROCESS_ELIGIBLE_STATUSES.includes(orderStatus as OrderStatusType)
}
